import Action from 'src/redux/action'
import { editedCampaign, editingCampaign } from 'src/redux/actions/campaigns'
import { CampaignContext, ContextState, NoContext } from 'src/context/types'

const context = (
  context: ContextState = NoContext(),
  action: Action,
): ContextState => {
  switch (action.type) {
    case editingCampaign.type:
      return CampaignContext(action.campaign, action.line)
    case editedCampaign.type:
      return NoContext()
    default:
      return context
  }
}

export default context
